import { ThemeProvider } from "@zendeskgarden/react-theming";
import { ReactElement, useEffect } from "react";
import useAppStore from "../../../../../hooks/useAppStore";
import { ViziblyTheme } from "../../../../../styles/zendesk-garden/ViziblyZDGTheme";
import { useAffordableRevenueSummaryLazyQuery } from "../../../../../__generated__/generated_types";
import { useProperties } from "../../../../../contexts/properties/PropertiesContext";
import { headerRowNoBottomMargin } from "../../../../../components/workflows/workflow-header/styles/css.module.scss";
import * as workflowHeaderCSS from "../../../../../components/workflows/workflow-header/styles/css.module.scss";
import * as workflowCSS from "../../../../../styles/workflows/workflowCSS.module.scss";
import "native-injects";
import WorkflowHeader from "../../../../../components/workflows/workflow-header/WorkflowHeader";
import WorkflowNavToggle from "../../../../../components/workflows/workflow-nav-toggle/WorkflowNavToggle";
import WorkflowPageLabel from "../../../../../components/workflows/workflow-page-label/WorkflowPageLabel";
import WorkflowStepNav from "../../../../../components/workflows/workflow-step-nav/WorkflowStepNav";
import { IWorkflowPageProps } from "../../../logic/workflows";
import { AffordableRevenueSummaryTable } from "./AffordableRevenueSummaryTable";

export function AffordableRevenueSummary(props: IWorkflowPageProps): ReactElement {
    const { currentProperty: property } = useProperties();
    const [loadData, { data, loading }] = useAffordableRevenueSummaryLazyQuery({ fetchPolicy: "no-cache" });
    const appStore = useAppStore();

    useEffect(() => {
        if (!property) {
            return;
        }

        loadData({
            variables: {
                propertyId: property.id,
                budgetYear: property.budgetYear,
            },
        });
    }, [property]);

    useEffect(() => {
        appStore.set({ isLoading: false });
    }, []);

    return (
        <ThemeProvider theme={ViziblyTheme}>
            <div className={workflowCSS.workflowContainer}>
                <WorkflowHeader className={headerRowNoBottomMargin}>
                    <WorkflowHeader.LeftCol>
                        <div className={workflowHeaderCSS.rowItemsContainer}>
                            <WorkflowNavToggle />
                            <WorkflowPageLabel label="Affordable Revenue Summary" />
                        </div>
                    </WorkflowHeader.LeftCol>
                    <WorkflowHeader.RightCol>
                        <div className={workflowHeaderCSS.columnItemsContainer}>
                            <WorkflowStepNav onPreviousClick={props.onPreviousClick} onNextClick={props.onNextClick} />
                        </div>
                    </WorkflowHeader.RightCol>
                </WorkflowHeader>
                <div className={`${workflowCSS.bodyContainer}`} style={{ padding: "1rem" }}>
                    {data && data.affordableRevenueSummary && !loading && property &&
                        <AffordableRevenueSummaryTable
                            summaryData={data.affordableRevenueSummary}
                            property={property}
                        />
                    }
                </div>
            </div>
        </ThemeProvider>
    );
}
